// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"88186000","545":"47df161b","787":"82daeaba"}[chunkId] + ".chunk.js";
};